import echarts from "echarts";

function _toFixed(value, floatWidth) {
	var val = value * 1;
	//处理：0
	if (!val) return ['0', ''.padEnd(floatWidth, '0')].join('.').replace(/\.$/g, '');

	var arr = val.toString().split('.');

	//处理没有小数
	if (arr.length == 1) return [arr[0], ''.padEnd(floatWidth, '0')].join('.').replace(/\.$/g, '');
	//处理有小数的
	else {
		//05
		var floatNum = arr[1].substring(0, floatWidth + 1).padEnd(floatWidth + 1, '0') * 1 + 5;
		//1000
		var floatStr = floatNum.toString();
		//没有进位
		if (floatStr.length <= floatWidth + 1) {
			return [arr[0], floatStr.substring(0, floatStr.length - 1).padStart(floatWidth, '0')].join('.').replace(/\.$/g, '');
		}
		//有进位
		else {
			return [arr[0] * 1 + 1, floatStr.substring(1, floatStr.length - 1)].join('.').replace(/\.$/g, '');
		}
	}
}

export default {

	install(Vue) {
		//以前的store_Env
		Vue.prototype.lm_env = window.lm_env;
		Vue.prototype.isLogin = function() {
			return !!JSON.parse(localStorage.getItem("login_user_" + window.lm_env));
		};
		Vue.prototype.$echarts = echarts;
		// 生成提示语句
		Vue.prototype.$getTip = function(message, position = "center") {
			let tip = this.$f7.toast.create({
				text: message,
				position: position,
				closeTimeout: 2000
			});
			return tip;
		};
		// 是否为空字符串
		Vue.prototype.$isEmpty = function(a) {
			if (a == undefined) return true;
			if (a == null) return true;
			if (typeof a === "string" && a.trim() == "") return true;
			return false;
		};

		Vue.prototype.$fixNumber = function(v, f) {
			if (f) return _toFixed(v, 2).replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
			else return _toFixed(v, 2);
		};
		Vue.prototype.$fixMoney = function(v, f) {
			var r = _toFixed(v, 2);
			if (Math.abs(r) >= 10000) {
				var _r = _toFixed(r * 1 / 1e4, 2).replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
				return _r + '万';
			} else return r.replace(/\d{1,3}(?=(\d{3})+\.\d*?$)/g, "$&,");
		};

		Vue.prototype.$getDate = function(s) {
			var date = new Date(s * 1);
			var YY = date.getFullYear() + '-';
			var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
			var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
			return YY + MM + DD;
		}
	}
}
